var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.boolShow),expression:"boolShow"}],staticClass:"cover-bg",on:{"click":_vm.toggleAside}})
}
var staticRenderFns = []

export { render, staticRenderFns }